import { defineStore } from 'pinia'
import { useAuthStore } from './auth'
import { createMessageProcessor } from '@/services/webSocketProcessor'
import { useDashboardStore } from './dashboard'

export const useWebsocketsStore = defineStore('websockets', () => {
  const socket = ref({})
  const connectionStatus = ref(false)
  const reconnectTimeout = ref(10000)

  const messageProcessor = createMessageProcessor(() => ({
    dashboardStore: useDashboardStore(),
  }))

  function handleSocketMessage(event) {
    messageProcessor.dashboardUpdate(event)
  }

  function connectSocket() {
    return new Promise((resolve, reject) => {
      const authStore = useAuthStore()
      const { login, token, session } = authStore.authUser || {}

      if (login && token && session) {
        const socketUrl = `wss://dispatcher.r1.robstor.com/ws/${login}/${session}/${token}`

        socket.value = new WebSocket(socketUrl)

        socket.value.onopen = () => {
          connectionStatus.value = true
          console.log('Подключение к сокету установлено.')
          resolve()
        }

        socket.value.onclose = () => {
          connectionStatus.value = false
          console.log('Подключение к сокету закрыто.')
          reconnect()
        }

        socket.value.onerror = (error) => {
          console.error('WebSocket error:', error)
          reject(error)
        }

        socket.value.onmessage = handleSocketMessage
      }
      else {
        reject(new Error('Cannot connect to WebSocket: Auth data is missing.'))
      }
    })
  }

  function disconnectSocket() {
    if (socket.value instanceof WebSocket) {
      socket.value.close()
      connectionStatus.value = false
    }
    else {
      console.warn('Socket is not initialized or is not a WebSocket instance.')
    }
  }

  function reconnect() {
    disconnectSocket()
    setTimeout(async () => {
      try {
        await connectSocket() // нужно дождаться завершения подключения; promise.all?
      }
      catch (error) {
        console.error('Reconnection failed:', error)
      }
    }, reconnectTimeout.value)
  }

  // function subscribeDashboardUpdates() {
  // подписываться не нужно, оно само приходит при установлении соединения
  // if (socket.value.readyState === WebSocket.OPEN) {
  //   socket.value.send(JSON.stringify({
  //     cmd: 'ticket',
  //     prm: 'update'
  //   }));
  // }
  // }

  // function unsubscribeDashboardUpdates() {
  // поэтому и  отписываться пока тоже не надо
  // }

  return {
    // State
    socket,
    connectionStatus,
    reconnectTimeout,

    // Actions
    connectSocket,
    disconnectSocket,

    // Subscription API
    // subscribe: (eventType, callback) => messageProcessor.subscribe(eventType, callback),
    // unsubscribe: (eventType, callback) => messageProcessor.unsubscribe(eventType, callback)
  }
})
